import React from "react";
import PropTypes from "prop-types";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";
import {USER_EVENT_THEME_COLORS, USER_EVENT_THEME_FONTS} from "./CreateEventConstants";
import standardEventCover from "../../../img/coriandoli.png";

export class CreateEventLandingStyleStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coverPreviewUrl: null,
        };
        this.previewStyle = {
            minHeight: "220px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
        };
        this.previewOverlayBaseStyle = {
            minHeight: "220px",
        };
        this.colorSwatchStyle = {
            height: "76px",
            cursor: "pointer",
        };
        this.fontCardStyle = {
            cursor: "pointer",
            minHeight: "78px",
        };
        this.fontCardSelectedStyle = {
            cursor: "pointer",
            minHeight: "78px",
            borderColor: "#293069",
            borderWidth: "1px",
        };
    }

    componentDidMount() {
        this.updateCoverPreviewUrl();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.eventData.cover !== this.props.eventData.cover) {
            this.updateCoverPreviewUrl();
        }
    }

    componentWillUnmount() {
        this.revokeCoverPreviewUrl();
    }

    revokeCoverPreviewUrl = _ => {
        if (this.state.coverPreviewUrl) {
            URL.revokeObjectURL(this.state.coverPreviewUrl);
        }
    }

    updateCoverPreviewUrl = _ => {
        this.revokeCoverPreviewUrl();
        if (this.props.eventData.cover) {
            this.setState({coverPreviewUrl: URL.createObjectURL(this.props.eventData.cover)});
            return;
        }
        this.setState({coverPreviewUrl: null});
    }

    getSelectedColor = _ => this.props.eventData.themeColor || USER_EVENT_THEME_COLORS[0].value

    getSelectedFontKey = _ => this.props.eventData.themeFont || Object.keys(USER_EVENT_THEME_FONTS)[0]

    getSelectedFont = _ => USER_EVENT_THEME_FONTS[this.getSelectedFontKey()] || USER_EVENT_THEME_FONTS.roboto

    getFontFamily = font => font.property.replace(" !important", "")

    getPreviewStyle = _ => ({
        ...this.previewStyle,
        backgroundImage: `url(${this.state.coverPreviewUrl || standardEventCover})`,
        fontFamily: this.getFontFamily(this.getSelectedFont()),
    })

    getPreviewOverlayStyle = _ => ({
        ...this.previewOverlayBaseStyle,
        background: `linear-gradient(180deg, ${this.getSelectedColor()}33 0%, ${this.getSelectedColor()}66 100%)`,
    })

    getColorSwatchStyle = color => ({
        ...this.colorSwatchStyle,
        backgroundColor: color.value,
        border: this.getSelectedColor() === color.value ? "2px solid #293069" : "0",
    })

    getFontCardStyle = fontKey => this.getSelectedFontKey() === fontKey ? this.fontCardSelectedStyle : this.fontCardStyle

    getFontPreviewStyle = font => ({
        fontFamily: this.getFontFamily(font),
    })

    handleColorChoose = color => _ => this.props.onDataChange("themeColor")(color)

    handleCustomColorChange = e => this.props.onDataChange("themeColor")(e.target.value)

    handleFontChoose = fontKey => _ => this.props.onDataChange("themeFont")(fontKey)

    formatEventDate = _ => {
        if (!this.props.eventData.startDate) {
            return "Data evento";
        }
        const eventDate = new Date(this.props.eventData.startDate);
        if (Number.isNaN(eventDate.getTime())) {
            return "Data evento";
        }
        return eventDate.toLocaleDateString("it-IT", {day: "numeric", month: "long"});
    }

    renderColor = color => (
        <div className={"col-4 col-md-2 mb-3"} key={color.key}>
            <div
                className={"rounded shadow-sm d-flex align-items-end justify-content-center text-white p-2"}
                style={this.getColorSwatchStyle(color)}
                onClick={this.handleColorChoose(color.value)}
            >
                <span className={"small font-weight-bold"}>{color.label}</span>
            </div>
        </div>
    )

    renderFont = fontKey => {
        const font = USER_EVENT_THEME_FONTS[fontKey];
        return (
            <div className={"col-6 col-md-4 mb-3"} key={fontKey}>
                <div
                    className={"card h-100 shadow-sm"}
                    style={this.getFontCardStyle(fontKey)}
                    onClick={this.handleFontChoose(fontKey)}
                >
                    <div className={"card-body text-center p-3"}>
                        <div className={"h3 font-weight-bold mb-1"} style={this.getFontPreviewStyle(font)}>
                            Aa
                        </div>
                        <div className={"small text-muted"}>{font.label}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className={"container py-3"}>
                <style>
                    {Object.keys(USER_EVENT_THEME_FONTS).map(fontKey => USER_EVENT_THEME_FONTS[fontKey].import).join("\n")}
                </style>

                <div className={"mb-3"}>
                    <h5 className={"font-weight-bold mb-1"}>Personalizza la landing</h5>
                    <div className={"text-muted"}>Scegli colori e tipografia della pagina evento.</div>
                </div>

                <div className={"card border-0 shadow-sm overflow-hidden mb-4"}>
                    <div style={this.getPreviewStyle()}>
                        <div className={"d-flex flex-column justify-content-end text-white p-3"} style={this.getPreviewOverlayStyle()}>
                            <h4 className={"font-weight-bold mb-1"}>{this.props.eventData.name || "Il tuo evento"}</h4>
                            <div className={"small"}>
                                <FaRegularIcon name={"calendar"} className={"mr-1"}/>
                                {this.formatEventDate()}
                            </div>
                        </div>
                    </div>
                    <div className={"bg-white p-3 text-muted"}>
                        {this.props.eventData.description || "Descrizione dell'evento..."}
                    </div>
                </div>

                <div className={"mb-4"}>
                    <div className={"font-weight-bold mb-2"}>
                        <span className={"text-magenta mr-1"}>
                            <FaSolidIcon name={"palette"}/>
                        </span>
                        Tema colori
                    </div>
                    <div className={"row"}>
                        {USER_EVENT_THEME_COLORS.map(this.renderColor)}
                    </div>
                    <div className={"card border-0 shadow-sm"}>
                        <div className={"card-body"}>
                            <label className={"font-weight-bold"}>Colore personalizzato</label>
                            <input
                                type={"color"}
                                className={"form-control"}
                                value={this.getSelectedColor()}
                                onChange={this.handleCustomColorChange}
                            />
                        </div>
                    </div>
                </div>

                <div className={"mb-5 pb-4"}>
                    <div className={"font-weight-bold mb-2"}>
                        <span className={"text-magenta mr-1"}>
                            <FaSolidIcon name={"font"}/>
                        </span>
                        Tipografia
                    </div>
                    <div className={"row"}>
                        {Object.keys(USER_EVENT_THEME_FONTS).map(this.renderFont)}
                    </div>
                </div>
            </div>
        );
    }
}

CreateEventLandingStyleStep.propTypes = {
    eventData: PropTypes.object,
    onDataChange: PropTypes.func,
};
